import { translate } from "../../util/translate"

export const customersListHeader = [
  {
    text: translate['customer.label.name'],
    value: 'name',
    width: '500',
  },
  {
    text: translate['customer.label.document'],
    value: 'cpfCnpj',
    width: '200',
  },
  {
    text: translate['customer.label.balance'],
    value: 'balance',
    width: '200',
  },
  {
    text: translate['customer.label.useCustomWorkerType'],
    value: 'use_custom_worker_type',
    align: 'center',
    width: '150',
  },
  {
    text: translate['host.label.linked'],
    value: 'with_service_provider',
    align: 'center',
    width: '150',
  },
  {
    text: 'ASAAS',
    value: 'id',
    align: 'center',
    width: '50',
  },
  {
    text: translate['customer.label.actions'],
    value: 'actions',
    align: 'center',
    width: '20',
  },
]
